import React from 'react';
import { useHistory } from 'react-router-dom';
import { authActionType, useAuthDispatch } from '@/plugins/Auth';

const Logout = () => {
  const history = useHistory();
  const authDispatch = useAuthDispatch();

  React.useEffect(() => {
    authDispatch({ type: authActionType.LOGOUT });
    setTimeout(() => history.replace('/'), 100);
  }, [history, authDispatch]);

  return (
    <div style={{ textAlign: 'center', paddingTop: 100, fontSize: '24px' }}>
      您已經成功登出
    </div>
  );
};

export default Logout;
